import { type ComponentStyleConfig, theme } from "@chakra-ui/theme";

const baseTabs = theme.components.Tabs.baseStyle;

export const Tabs: ComponentStyleConfig = {
  ...theme.components.Tabs,
  baseStyle: (props) => {
    const base =
      typeof baseTabs === "function" ? baseTabs(props) : baseTabs ?? {};
    return {
      ...base,
      tab: {
        ...base.tab,
        _focus: {
          outline: "none !important",
        },
        _focusVisible: {
          outline: "none",
          boxShadow: "outline",
        },
      },
    };
  },
};
